import { switchAll as higherOrder } from 'rxjs/operators';
export function _switch() {
    return higherOrder()(this);
}
//# sourceMappingURL=switch.js.map